import { useContext, useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from 'react-router';
import { useTranslation } from 'react-i18next';

import { NotificationType, PublicLead } from "shared/topchef.types";
import api from 'shared/topchef-api-places';
import Loading from "pages/shared/loading/Loading";
import PublicLeadContent from "pages/shared/public-lead-content/PublicLeadContent";
import { PlaceOutletContextType } from "pages/places/home/PlacesHome";
import { NotificationContext } from "shared/NotificationContext"
import { useErrorBoundary } from "react-error-boundary"
import FollowLeadButton from "./follow-lead-button/FollowLeadButton";

const AvailableLeadDetails = () => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loggedInPlace] = useOutletContext<PlaceOutletContextType>();

  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;

  const params = useParams();
  const leadId: string = params.leadId || '';

  const [publicLeadLoaded, setPublicLeadLoaded] = useState<boolean>(false);
  const [publicLead, setPublicLead] = useState<PublicLead | null>(null);

  const { showBoundary } = useErrorBoundary();

  useEffect(() => { // eslint-disable-line react-hooks/exhaustive-deps

    async function loadPublicLead() {
      try {
        const lead: PublicLead = await api.loadPublicLead(loggedInPlace!.id, leadId);
        setPublicLead(lead);
        setPublicLeadLoaded(true);
      } catch (error: any) { 
        const newError = new Error(t('apiErrors.loadPublicLeadDetails', { details: error.message }) as string);
        triggerNotification({type: NotificationType.error, message : newError.message});
        return showBoundary(newError);
      } 
    }

    if (publicLeadLoaded) {
      return;
    }
    loadPublicLead();

  }, [publicLeadLoaded, publicLead, leadId, loggedInPlace, triggerNotification, showBoundary]); // eslint-disable-line react-hooks/exhaustive-deps


  const followLead = async () => {
    try {
      await api.followLead(loggedInPlace!.id, leadId);
      navigate(`/places/leads/followed/${leadId}`);
    } catch (error: any) {
      triggerNotification({type: NotificationType.error, message : t('apiErrors.followLead', { details: error.message })}); 
    }
  };

  function backToBriefMarket(): void {
    navigate('/places/available-leads');
  }

  if (!publicLeadLoaded) {
    return (
      <Loading />
    );
  }

  function isFollowAllowed(): boolean {
    return (publicLead!.status === 'available' || publicLead!.status === "followed") 
            && loggedInPlace!.id !== publicLead!.sourceId
            && publicLead!.availableSlots > 0;
  }

  return (

      <div className="container page-briefs-single-details p-2 col-md-6 overflow-auto">
        <div id="lead_sidebar" className="d-flex">
          <ul className="nav nav-pills flex-column mb-auto">
            <li className="nav-item"> <a href="/places/share-a-lead" type="button" className="btn btn-outline-primary nav-link add-brief-link">{t('common.addBrief')}</a></li>
          </ul>
        </div>
       
        <PublicLeadContent publicLead={publicLead!} />

        <div className="text-center">
            <div className="text-center btn-list">
            {isFollowAllowed() &&
              <span className="position-instructions row mb-3">{t('availableLead.positionInstructions')}</span>
            }
                <button id="cancel_brief_submission" className="cancel-btn btn btn-primary m-3" onClick={backToBriefMarket}>{t('availableLead.returnToBriefs')}</button>
                {isFollowAllowed() ?
                  <FollowLeadButton followLead={followLead} loggedInPlace={loggedInPlace} lead={publicLead!}/>
                  :
                <div className="brief_slots_full mt-3">
                    <p className="text-danger">{t('availableLead.cannotPosition')}</p>
                </div>
                }
            </div>
        </div>
    </div>
     
  );

}

export default AvailableLeadDetails;

